/**
 * Enum that represent the workfllow action asked by user
 */
export enum WorkflowTargetState {
  RETREAT = 'RETREAT',
  ACCEPT = 'ACCEPT',
  REFUSE = 'REFUSE'
}
